import React, { useMemo } from 'react'
import { PanelId, usePanelRegistry } from './panel-registry'
import { SidebarRailChrome } from './sidebar-rail-chrome'

export function SidebarRail() {
  const definitions = usePanelRegistry(r => r.definitions)
  const primaryPanelIds = useMemo(() => {
    return Object.keys(definitions).filter(id => definitions[id].role === "primary")
  }, [ definitions ])

  const bySortOrder = (a: string, b: string) =>
    (definitions[a].sortOrder ?? 0) - (definitions[b].sortOrder ?? 0)

  const topIcons = primaryPanelIds
    .filter(panelId => definitions[panelId].position !== "bottom")
    .sort(bySortOrder)

  const bottomIcons = primaryPanelIds
    .filter(panelId => definitions[panelId].position === "bottom")
    .sort(bySortOrder)

  return (
    <SidebarRailChrome>
      {topIcons.map((panelId, i) => (
        <React.Fragment key={panelId}>
          {i > 0 && definitions[topIcons[i - 1]].railGroup !== definitions[panelId].railGroup && (
            <SidebarRailChrome.Separator />
          )}
          <SidebarRailIcon id={panelId} />
        </React.Fragment>
      ))}
      <div className="flex-grow" />
      {bottomIcons.map(panelId => <SidebarRailIcon key={panelId} id={panelId} />)}
    </SidebarRailChrome>
  )
}

function SidebarRailIcon(props: {
  id: PanelId
}) {
  const definition = usePanelRegistry(r => r.definitions[props.id])
  const isOpen = usePanelRegistry(r => r.openPanels.has(props.id))
  const isFloating = usePanelRegistry(r => r.floatingPanels.includes(props.id))
  const toggle = () => {
    if (isFloating) {
      usePanelRegistry.getState().dockPanel(props.id)
      usePanelRegistry.getState().closePanel(props.id)
    } else {
      if (isOpen) {
        usePanelRegistry.getState().closePanel(props.id)
      } else {
        usePanelRegistry.getState().openPanel(props.id)
      }
    }
  }
  const badgeRenderer = usePanelRegistry(r => r.badgeRenderers[props.id])

  if (!definition) return null
  if (!definition.icon) return null

  return (
    <SidebarRailChrome.Icon
      icon={definition.icon}
      title={definition.title}
      active={isOpen}
      semiActive={isFloating}
      onClick={toggle}>
      {badgeRenderer && badgeRenderer()}
    </SidebarRailChrome.Icon>
  )
}